import { useState } from "react"
import { Link } from "react-router-dom"

const Tabs = ({ tab, setTab }) => {
    const tabs = ["Overview", "Projects"];
  return (
    <nav className="flex items-center justify-center p-2 bg-gray-200 space-x-6 w-fit rounded-md">
         {tabs.map((t) => (
          <button key={t}
          className={`relative w-24 text-center py-2 rounded-md font-medium text-sm transition-all duration-500 ${tab === t ? "bg-white shadow-md" : "hover:bg-gray-300"}`}
          onClick={() => setTab(t)}>
            {t}
          </button>
         ))}
        </nav>
  )
}
export default Tabs